import HighlightedStateManager from './stateManager';
import DomManipulator, { DOM_CLASSES } from './domManipulator';

class HighlightingService {
  constructor() {
    this.stateManager = new HighlightedStateManager();
    this.domManipulator = new DomManipulator();
  }

  registerDNAGraph = () => {
    this.domManipulator.registerDNAGraph();
  };

  registerSummary = (recommendations, allTags, topTags) => {
    this.stateManager.registerSummary(recommendations, allTags, topTags);
  };

  highlightRecommendation = recommendation => {
    this.stateManager.highlightRecommendation(recommendation);
    this.updateDom();
  };

  highlightTag = tag => {
    this.stateManager.highlightTag(tag);
    this.updateDom();
  };

  resetHighlighting = event => {
    if (
      event.relatedTarget &&
      event.relatedTarget.classList &&
      DOM_CLASSES.find(className =>
        event.relatedTarget.classList.contains(className)
      )
    ) {
      return;
    }

    this.stateManager.reset();
    this.updateDom();
  };

  // "Private"
  updateDom = () => {
    this.domManipulator.updateDom(this.stateManager.state);
  };
}

export default new HighlightingService();



// WEBPACK FOOTER //
// ./src/services/highlightingService/index.js